export const cookieName = 'vup-redirect-destination';
export const redirectPreferenceCachedCookie = 'vup-redirect-preference-cached';

export const redirectTypes = {
  custom: 'custom',
  isp: 'isp',
  device: 'device',
  geo: 'geo',
  cookie: 'cookie',
  firstTime: 'first_view',
  cardAuto: 'card_auto',
  regionMatching: 'region_matching',
  quota: 'quota'
};

export const browserRedirectMode = {
  transition: 'transition',
  simple: 'simple'
};

export const redirectActions = {
  auto: 'auto',
  cancel: 'cancel',
  appLaunchView: 'app_launch_view',
  appLaunchClick: 'app_launch_click',
  appDownloadClick: 'app_download_click'
};

export const firstTimeRedirectActions = {
  default: 'default',
  noRedirect: 'no_redirect',
  networkRedirect: 'network_redirect'
};
